// extracted by mini-css-extract-plugin
export default {"iconDownload":"_2S2Ky","cell":"_2o9oA","table":"_1MVR8","paypalcellMode":"_1RWfP"};